import Swal from "sweetalert2"

export const copyToPayment = async (generateUrl: () => Promise<string>) => {
    try {
        const url = await generateUrl()

        // O clipboard pode ser bloqueado após a requisição (perda do gesto do usuário em alguns navegadores)
        let copied = true
        try {
            await navigator.clipboard.writeText(url)
        } catch {
            copied = false
        }

        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: copied ? 'Link copiado com sucesso!' : 'Link de pagamento gerado',
            html: `<input type="text" readonly value="${url}" class="form-control mt-3" onclick="this.select()" />`,
            customClass: {
                confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
                cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
            },
        })
    } catch (error: any) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.response?.data?.message ?? 'Erro ao gerar link de pagamento.',
            timer: 2000,
            customClass: {
                confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
                cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
            },
        })
    }
}
